(() => {
    let starGroup = '';
    let starSingle = '';
    var window_width = null;
    widthActual();

    window.onload = function () {
        window.addEventListener("resize", (event) => {
            widthActual();
        });

        let reviewsContainer = document.getElementsByClassName('rating-with-reviews');
        
        if(reviewsContainer) {
            let starGroup = document.getElementsByClassName('bv_stars_svg_no_wrap');
            
            for (let i = 0; i < reviewsContainer.length; i++) {
                reviewsContainer[i].style.opacity = '0';
            }
            
            getHeart().then((heartContainer) => {
                setTimeout(() => {
                    for (let i = 0; i < heartContainer.length; i++) {
                        let svgIcon = heartContainer[i].getElementsByTagName('svg');
                        svgIcon[0].removeAttribute('width')
                        svgIcon[0].removeAttribute('height')
                        svgIcon[0].classList.add('svgIcon');
                    }
                }, 500);

            });

            getStars(starGroup).then(() => {
                for (let i = 0; i < reviewsContainer.length; i++) {
                    reviewsContainer[i].style.opacity = '1';
                }
            }).catch((err) => {
                console.error(err);
            })
        }

    };

    const getStars = (starContainer) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                for(let i = 0; i < starContainer.length; i++) {
                    let stars = starContainer[i];
                    starSingle = stars.getElementsByTagName('svg')
                    
                    for (let x = 0; x < starSingle.length; x++) {
                        starSingle[x].removeAttribute("width");
                        starSingle[x].removeAttribute("height");
                        starSingle[x].removeAttribute("style");
                    }
                }
                resolve();
            }, 1300);
            
        })
    }

    function getHeart() {
        return new Promise((resolve, reject) => {
            let heartContainer = document.getElementsByClassName('swym-wishlist-collections-v2');
            resolve(heartContainer);
        });

    }

    function widthActual() {
        window_width = window.innerWidth;
    }
})()